import { render, staticRenderFns } from "./AreYouSureDialog.vue?vue&type=template&id=bcd03fb6&scoped=true&"
import script from "./AreYouSureDialog.vue?vue&type=script&lang=ts&"
export * from "./AreYouSureDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AreYouSureDialog.vue?vue&type=style&index=0&id=bcd03fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd03fb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardActions,VCardText,VCardTitle})
